module.exports = __webpack_public_path__ + "static/media/logo.870f1de3.jpg";